import axios from "axios";
import { BACKEND_URL } from "../lib/backend";

const API = `${BACKEND_URL}/api/pulse`;

export const pulseGet = (path, params) =>
  axios.get(`${API}/${path}`, { params }).then((r) => r.data);

export const pulsePost = (path, body) =>
  axios.post(`${API}/${path}`, body || {}).then((r) => r.data);
